import React, { createContext, useContext } from 'react';

/** App-level auth + shell state shared with routes (createBrowserRouter layout). */
export const AuthContext = createContext(null);

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error('useAuth must be used within AuthContext.Provider');
  }
  return ctx;
}
